function sanitize(value: string): string {
	return value
		.replace(/\s/g, '-')
		.replace(/[^a-zA-Z0-9-]/g, '')
		.toLowerCase()
		.trim();
}

export default { sanitize };
